module.exports = __webpack_public_path__ + "static/image/company/pc/image_resolutions.jpg?ff31d214";